import React from "react";
import { createRoot } from "react-dom/client";
import PageHeaderChrome from "./pageHeaders/PageHeaderChrome";

// Bridge that lets a legacy v1 page (React 18, separate bundle) render a v2
// React 19 page header. v1 cannot import v2 modules, so the seam is a window
// global plus DOM nodes - the same isolation the chrome navbar/footer roots use.
// Only plain data + callbacks cross it (see the header definitions); no React
// element or context ever does.
//
// One React root per host element, cached in a WeakMap so a re-mount of the same
// element is a re-render (React reconciles in place - a term change updates the
// header with no flicker and no leaked root). The host element is owned by the
// v1 V2PageHeader component, which calls unmount on cleanup when its route leaves.
const roots = new WeakMap();

function mountPageHeader(el, headerKey, params) {
  if (!el) return;
  let root = roots.get(el);
  if (!root) {
    root = createRoot(el);
    roots.set(el, root);
  }
  root.render(<PageHeaderChrome headerKey={headerKey} params={params} />);
}

function unmountPageHeader(el) {
  const root = el && roots.get(el);
  if (!root) return;
  root.unmount();
  roots.delete(el);
}

// Namespaced merge so other chrome surfaces can attach their own helpers here.
window.AeChrome = {
  ...(window.AeChrome || {}),
  mountPageHeader,
  unmountPageHeader,
};

// The chrome bundle is a separate script from the v1 SPA and can evaluate after
// a v1 page has already mounted (notably in dev, where this is a Vite module
// graph fetched over the network). A v1 V2PageHeader that mounted before this
// ran found no window.AeChrome; signal readiness so it can mount now instead of
// waiting for an unrelated re-render that may never come.
window.dispatchEvent(new Event("aechrome:ready"));
